import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useEmojisQuery = createQueryHook(MembershipsCreatorApiClient.getEmojis, {
  queryKey: ['emojis'],
})
